var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-row',{staticClass:"flex-1 spinner-cnt",attrs:{"justify":"center","type":"flex"}},[_c('a-spin',{attrs:{"size":"large"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }